/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createMessageDetailFromDiscriminatorValue, createProblemDetailsFromDiscriminatorValue, type MessageDetail, type ProblemDetails } from '../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /messages/{id}
 */
export interface MessagesItemRequestBuilder extends BaseRequestBuilder<MessagesItemRequestBuilder> {
    /**
     * GetMessage
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<MessageDetail>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<MessageDetail | undefined>;
    /**
     * GetMessage
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const MessagesItemRequestBuilderUriTemplate = "{+baseurl}/messages/{id}";
/**
 * Metadata for all the requests in the request builder.
 */
export const MessagesItemRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: MessagesItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createMessageDetailFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
